"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NewTab = void 0;

var _react = _interopRequireDefault(require("react"));

var _core = require("@material-ui/core");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var NewTab = function NewTab(props) {
  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, props, /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9997 3.00006C13.9997 2.44778 14.4474 2.00006 14.9997 2.00006H20.9997C21.552 2.00006 21.9997 2.44778 21.9997 3.00006V9.00006C21.9997 9.55235 21.552 10.0001 20.9997 10.0001C20.4474 10.0001 19.9997 9.55235 19.9997 9.00006V5.41463L10.7071 14.7072C10.3166 15.0978 9.68342 15.0978 9.29289 14.7072C8.90237 14.3167 8.90237 13.6836 9.29289 13.293L18.5859 4.00006H14.9997C14.4474 4.00006 13.9997 3.55235 13.9997 3.00006ZM4.2924 7.29295C4.47994 7.10542 4.73429 7.00006 4.99951 7.00006H10.9995C11.5518 7.00006 11.9995 6.55235 11.9995 6.00006C11.9995 5.44778 11.5518 5.00006 10.9995 5.00006H4.99951C4.20386 5.00006 3.4408 5.31613 2.87819 5.87874C2.31558 6.44135 1.99951 7.20441 1.99951 8.00006V19.0001C1.99951 19.7957 2.31558 20.5588 2.87819 21.1214C3.4408 21.684 4.20386 22.0001 4.99951 22.0001H15.9995C16.7952 22.0001 17.5582 21.684 18.1208 21.1214C18.6834 20.5588 18.9995 19.7957 18.9995 19.0001V13.0001C18.9995 12.4478 18.5518 12.0001 17.9995 12.0001C17.4472 12.0001 16.9995 12.4478 16.9995 13.0001V19.0001C16.9995 19.2653 16.8942 19.5196 16.7066 19.7072C16.5191 19.8947 16.2647 20.0001 15.9995 20.0001H4.99951C4.7343 20.0001 4.47994 19.8947 4.2924 19.7072C4.10487 19.5196 3.99951 19.2653 3.99951 19.0001V8.00006C3.99951 7.73484 4.10487 7.48049 4.2924 7.29295Z"
  }));
};

exports.NewTab = NewTab;